<template>
  <q-page>
    <p>external return</p>
  </q-page>
</template>

<script>
    import dataList from '../_list'
    import orderColumns from '../orderColumns'
    import stockColumns from '../stockColumns'
    import lendingKitColumns from '../lendingKitColumns'
    import orderDetail from '../_orderDetail'
    import lendingKitDetail from '../_lendingKitDetail'

export default {
        middleware: 'auth',

        mixins: [orderColumns, lendingKitColumns, stockColumns],

        components: {
            dataList,
            orderDetail,
            lendingKitDetail
        },

        props: {
            slug: String,
            singular: String,
            plural: String,
            icon: String,
            columnsDef: String,
            tabFilterDef: String,
            detailComp: String,
            createRoute: String,
            exportRoute: String,
            directExportRoute: String,
        },
                data() {
            return {
                modalDetail: false,
                item: {}
            }
        },
        methods: {
            showDetail(item) {
                this.item = item
                this.modalDetail = true
            },

            refreshList() {
                this.$refs.list.refreshRows()
            }
        },

        computed: {
            translatedColumns() {
                return this[this.columnsDef].map(column => {
                    return {
                        name: column.field,
                        label: this.$T(column.label),
                        field: column.field,
                        align: column.align || 'left',
                        sortable: column.sortable || false,
                        required: column.required || false
                    }
                })
            },
            translatedTabFilters () {
                return this[this.tabFilterDef]
            }
        }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// resources/assets/js/pages/lending-point/externalReturn.vue